











































































































import { Component, Vue } from "vue-property-decorator";
import WebServiceMarkup from "@/store/entities/flight/webServiceMarkup";
import Currency from "@/store/entities/currency";
import AuxiliaryService from "@/store/entities/flight/auxiliaryService";

@Component({})
export default class AddMarkupModal extends Vue {
  dialog: boolean = true;
  webServiceMarkup: WebServiceMarkup = new WebServiceMarkup();
  webServiceMarkups: WebServiceMarkup[] = [];
  currencies: Currency[] = [];
    currency: Currency = new Currency();

  isEdit: boolean = false;
  auxiliaryServices: AuxiliaryService[] = [];
  auxiliaryService:AuxiliaryService=new AuxiliaryService();





   async created() {
    
     await this.getCurrencies();
    await this.getAuxiliaryMarkups();
     await this.getAuxiliaryServices();


     this.webServiceMarkup = this.$store.state.webServiceMarkup.editAuxiliaryMarkup;
  
    if (this.webServiceMarkup == null) {
      this.isEdit = false;
      this.webServiceMarkup = new WebServiceMarkup();
      
    } else {
      this.isEdit = true;
   
      var currency= this.currencies.find(x=>x.id==this.webServiceMarkup.currencyId);  
      this.auxiliaryService=  this.webServiceMarkup.service;
      this.webServiceMarkup.currency=currency;
 
      
    }

  }


    async saveAuxiliaryMarkup() {
      this.webServiceMarkup.service=this.auxiliaryService;
      this.webServiceMarkup.currencyId=this.webServiceMarkup.currency.id;
      
    if (!this.isEdit) {
      await this.$store.dispatch({
         type: "webServiceMarkup/addAuxiliaryServiceMarkup",
        data: this.webServiceMarkup,
      });

      Vue.$toast.success("Kayıt Eklendi");
      this.closeDialog();
    } else {
      await this.$store.dispatch({
         type: "webServiceMarkup/saveAuxiliaryServiceMarkup",
        data: this.webServiceMarkup,
      });

      Vue.$toast.success("Kayıt Güncellendi");

      this.closeDialog();
    }
  }



    async getCurrencies() {
    await this.$store.dispatch({
      type: "currency/getCurrencies",
    });

    this.currencies = this.$store.state.currency.list;
  
  }

    async getAuxiliaryMarkups() {
    await this.$store.dispatch({
      type: "webServiceMarkup/getAuxiliaryServiceMarkups"
    });
    
   this.webServiceMarkups = this.$store.state.webServiceMarkup.list;
    
  }

      async getAuxiliaryServices() {
    await this.$store.dispatch({
      type: "auxiliaryService/getAuxiliaryServices"
    });
    
   this.auxiliaryServices = this.$store.state.auxiliaryService.list;
    
  }




  closeDialog() {
    this.$emit("closed");
  }
}
